import styled from 'styled-components';
import { device } from '../../../styles/breakpoints';

export const RegisterFormContainer = styled.div``;

export const DoubleColumnFields = styled.div`
  display: flex;
  gap: 24px;
  margin: 0;

  @media ${device.tablet} {
    gap: 0px;
    flex-direction: column;
    margin: 0;
  }
`;

export const DoubleColumnFieldWrapper = styled.div`
  margin: 0;
  flex: 1;

  @media ${device.tablet} {
    :first-child {
      margin-bottom: 24px;
    }
    display: flex;
  }
`;

export const FieldWrapper = styled.div`
  margin: 24px 0;
  flex: 1 1;
  display: flex;
`;
